// @flow
import jsStorage from 'js-storage';

interface IJsStorage {
	initNamespaceStorage(): any
}

class JsStorageProvider {
	initNamespaceStorage (key: string) {
		return jsStorage.initNamespaceStorage(key);
	}
}

const takeDefaultStorage = () => new JsStorageProvider();

export class StorageExecutor {
	_jsStorageProvider: IJsStorage; //tightly coupled
	_storage: *;

	constructor (storage: IJsStorage) {
		this._jsStorageProvider = storage || takeDefaultStorage();
	}

	registerNamespace (key: string) {
		this._storage = this._jsStorageProvider
			.initNamespaceStorage(key)
			.localStorage;
	}

	isSet (key: string): boolean {
		return this._storage.isSet(key);
	}

	get (key: string): * {

		if (!this._storage) {
			throw new Error("Storage hasn't initiated yet");
		}

		return this._storage.get(key) || false;
	}

	set (key: string, data: *) {
		this._storage.set(key, data);
	}

	_markAsBooleanTouched (key: string) {
		this.set(key, true);
	}

	callIfFalse (key: string, callback: () => *) {
		if (!this.isSet(key)) {
			callback();
			this._markAsBooleanTouched(key);
		}
	}

	callIfTrue (key: string, callback: () => *) {
		if (this.isSet(key)) {
			callback();
			this._markAsBooleanTouched(key);
		}
	}
}
